import { create } from "zustand";
import type { VoucherDistribution } from "../models/voucher-distribution";

type VouchersDistributionState = {
  voucherDistribution?: VoucherDistribution;
  setVoucherDistribution: (voucherDistribution: VoucherDistribution) => void;
};

// Pre-read `gon.voucherDistribution` (Rails injects it into window.gon) at
// module load time so the very first React render already has the data.
// This avoids an extra `<Loader />` render cycle that would delay the
// mounting of `useTrackPageViews` and, in turn, the first `page_view` push.
const getInitialVoucherDistribution = (): VoucherDistribution | undefined => {
  if (typeof window === "undefined") return undefined;
  const gonData = (window as unknown as { gon?: { voucherDistribution?: VoucherDistribution } }).gon;
  return gonData?.voucherDistribution;
};

export const useVouchersDistributionState = create<VouchersDistributionState>((set) => ({
  voucherDistribution: getInitialVoucherDistribution(),
  setVoucherDistribution: (voucherDistribution) =>
    set(() => ({
      voucherDistribution,
    })),
}));
